import { CSSProperties, ReactNode } from 'react';
// form
import { FieldValues, FormProvider as Form, UseFormReturn } from 'react-hook-form';

// ----------------------------------------------------------------------

interface Props<T extends FieldValues> {
  children: ReactNode;
  methods: UseFormReturn<T>;
  onSubmit?: VoidFunction;
  debug?: boolean;
  style?: CSSProperties | undefined;
}

export default function FormProvider<T extends FieldValues>({
  children,
  onSubmit,
  methods,
  debug,
  style
}: Props<T>) {
  if (debug) {
    console.log({
      action: 'FormProvider render',
      values: methods.watch(),
      ...methods.formState,
    });
  }

  return (
    <Form {...methods}>
      <form style={style} onSubmit={onSubmit}>{children}</form>
    </Form>
  );
}
